import React from 'react';

import IconMenuAccount from './IconMenuAccount';
import { Section, H1 } from './styles';

const HeaderBarDashBoard = ({title}) => (
    <Section>
        <H1>{title}</H1>
        <IconMenuAccount />
    </Section>
);

export default HeaderBarDashBoard;